/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/tabindex-no-positive */
/* eslint-disable react/no-unstable-nested-components */
import Container from '@brands/Components/Container/Container';
import MuiPhoneInput from '@brands/Components/Inputs/MuiTelInput/MuiTelInput';
import CustomTextField from '@brands/Components/Inputs/MuiTextField/TextField';
import OldPhoneInput from '@brands/Components/Inputs/PhoneInput/PhoneInput';
import UnsavedChangesModal from '@brands/Dashboard/Dashboard/Components/UnsavedChangesModal/UnsavedChangesModal';
import AddressSection from '@brands/Dashboard/Dashboard/SuperAdmin/Components/AddressSection/AddressSection';
import { hasBasicInfoChanged, hasMeChanged } from '@brands/Dashboard/MyProfile/OrganizationAdmin/helpers';
import ChangePasswordModal from '@brands/Dashboard/Sidenav/SidenavModals/ChangePasswordModal/ChangePasswordModal';
import { useUnsavedChangesWarning } from '@brands/hooks/useUnsavedChangesWarning';
import { updateVerifiedEmail } from '@brands/services/identity/updateUserEmail';
import { mapProfileToMyProfileSubmit } from '@brands/store/actions/adminAction';
import { selectAuth } from '@brands/store/selectors/auth';
import { setUser } from '@brands/store/slices/authSlice';
import { UnifiedProfileSubmit } from '@brands/Utils/types';
import { validateAddress, ValidationModalInterface } from '@brands/Utils/validateAddress';
import { yupResolver } from '@hookform/resolvers/yup';
import { Button as MuiButton } from '@mui/material';
import cn from 'classnames';
import { E164Number, parsePhoneNumber } from 'libphonenumber-js';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useForm, UseFormGetValues, useWatch } from 'react-hook-form';
import { FiEdit } from 'react-icons/fi';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import BlueCircle from '../../../assets/icons/light-blue-circle.svg';
import GrayCircle from '../../../assets/icons/light-gray-circle.svg';
import Button from '../../../Components/Button/Button';
import TextField from '../../../Components/Inputs/TextField/TextField';
import { Loading } from '../../../Components/LoadingSpinner/Loading';
import ProfileImage from '../../../Components/ProfileImage/ProfileImage';
import { useAppDispatch, useAppSelector } from '../../../hooks/useReduxHook';
import { defaultUserValues } from '../../../services/cases/types/defaultUserValues';
import { RegisterMediaPayload } from '../../../services/communication/registersConversationMedia';
import { confirmAvatarMedia } from '../../../services/identity/confirmAvatarMedia';
import { createBasicInformation } from '../../../services/identity/createBasicInformation';
import { deleteAvatar } from '../../../services/identity/deleteAvatar';
import { getCurrentProfile } from '../../../services/identity/getCurrentProfile';
import { getUserById } from '../../../services/identity/getUserById';
import { getUserAvatar } from '../../../services/identity/getUserAvatar';
import { registerAvatarMedia } from '../../../services/identity/registerAvatarMedia';
import { saveBasicInformation } from '../../../services/identity/saveBasicInformation';
import { Address, BasicInfo, UserProfile, UserRoleName } from '../../../services/identity/types/UserProfile';
import { UpdateMe, updateMe } from '../../../services/identity/updateMe';
import { displayErrorDetails } from '../../../Utils/displayError';
import Sidenav from '../../Sidenav/Sidenav';
import ModernReviewProfileHeader from '../Components/ModernReviewProfileHeader';
import ChangeUserStatusModal from '../Modal/ChangeUserStatusModal';
import ResetPasswordModal from '../Modal/ResetPasswordModal';
import { updateData } from '../Patient/utils/utilsFunctions';
import newProfileStyles from '../SuperAdmin/styles.module.scss';
import styles from '../styles.module.scss';
import { AdminMyProfileSubmit } from './utils/types';
import { validationSchema } from './utils/validationSchema';

type ReviewMyProfileProps = {
  reviewProfile?: boolean;
};

const MyProfile = ({ reviewProfile }: ReviewMyProfileProps): JSX.Element => {
  const userId = useParams().userId as string;
  const roleName = useParams().role as string;
  const { userInfo } = useAppSelector(selectAuth);
  const [thisUser, setThisUser] = useState<UserProfile>(userInfo || defaultUserValues);
  const [image, setImage] = React.useState<string>();
  const [currentAvatarURL, setCurrentAvatarURL] = useState<string>('');
  const [avatarFile, setAvatarFile] = useState<File | null>(null);
  const [avatarPayload, setAvatarPayload] = useState<RegisterMediaPayload | null>(null);
  const [validationResponseId, setValidationResponseId] = useState('');
  const [avatarAction, setAvatarAction] = useState<string>('');
  const [loading, setLoading] = useState(true);
  const [isEditProfile, setIsEditProfile] = useState(Boolean(reviewProfile));
  const [render, setRender] = useState(false);
  const phoneInputRef = useRef<HTMLInputElement>(null);
  const dispatch = useAppDispatch();
  const [resetPasswordConfirmation, setResetPasswordConfirmation] = useState<{ isOpen: boolean; userState: string }>({
    isOpen: false,
    userState: thisUser.state || '',
  });
  const [showValidationAddressModal, setShowValidationAddressModal] = useState<ValidationModalInterface>({
    isOpen: false,
    title: '',
    whatYouEntered: '',
    recommended: false,
    recommendedAddress: '',
    onClose: undefined,
    onConfirmChange: undefined,
    onKeepCurrentAddress: undefined,
  });
  const [changeUserStatusFlag, setChangeUserStatusFlag] = useState('');
  const [resetEmailSent, setResetEmailSent] = useState(false);
  const [isSavingProfile, setIsSavingProfile] = useState(false);
  const [changePasswordOpen, setChangePasswordOpen] = useState(false);
  const formRef = useRef<HTMLFormElement>(null);
  const imageObjectUrlRef = useRef<string | null>(null);
  const disableButton = (): void => {
    setResetEmailSent(true);
  };
  const disableDeleteButton = (): void => {
    setThisUser({
      ...thisUser,
      status: 'Deactivated',
    });
  };
  const [myProfileForm, setMyProfileForm] = useState<AdminMyProfileSubmit>({} as AdminMyProfileSubmit);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    getValues,
    control,
    watch,
  } = useForm<AdminMyProfileSubmit>({
    mode: 'onChange',
    resolver: yupResolver(validationSchema),
  });

  const watchedValues = useWatch({ control });

  /**
   * `myProfileForm` gets rebuilt from scratch (dropping `profile_img`) whenever `thisUser`
   * re-fetches, which happens right after the avatar URL loads asynchronously — so comparing
   * it against the live form values directly permanently disagrees even with nothing to save.
   * Track real edits via the watch subscription instead, guarded by isHydratingFormRef so
   * data-loading setValue calls (initial hydration, avatar hydration) aren't mistaken for
   * user edits.
   */
  const isHydratingFormRef = useRef(false);
  const [hasEditedSinceSave, setHasEditedSinceSave] = useState(false);

  useEffect(() => {
    const subscription = watch(() => {
      if (!isHydratingFormRef.current) {
        setHasEditedSinceSave(true);
      }
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  const hasUnsavedChanges = useMemo(
    () => render && (hasEditedSinceSave || avatarAction !== ''),
    [avatarAction, hasEditedSinceSave, render],
  );

  const { showModal, confirmNavigation, saveChanges, hideModal } = useUnsavedChangesWarning(
    hasUnsavedChanges,
    formRef,
  );

  const updateCurrentAddress = (standardizedAddress: any, postalAddress: any, addressComponents: any): void => {
    const streetNumber = addressComponents.find(
      (addressComponent: any) => addressComponent.componentType === 'street_number',
    );
    const address1 = addressComponents.find((addressComponent: any) => addressComponent.componentType === 'route');
    const state = addressComponents.find(
      (addressComponent: any) => addressComponent.componentType === 'administrative_area_level_1',
    );

    if (postalAddress) {
      setValue('city', postalAddress.locality);
      setValue('zip_code', postalAddress.postalCode);
    }

    if (streetNumber || address1) {
      setValue('address1', `${streetNumber?.componentName?.text || ''} ${address1?.componentName?.text || ''}`.trim());
    }

    if (state) {
      setValue('state', state.componentName?.text || '');
    } else if (standardizedAddress?.state) {
      setValue('state', standardizedAddress.state);
    }
  };

  const getCurrentUser = async (id: string): Promise<void> => {
    try {
      setLoading(true);
      if (reviewProfile && userId) {
        const currentUser = await getUserById(Number(id));
        setThisUser(currentUser);
      }
    } catch (error: unknown) {
      displayErrorDetails(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchUserDetails = async (): Promise<void> => {
    const userDetails = await getCurrentProfile();
    setThisUser(userDetails);
  };

  const fetchProfile = (): void => {
    const mappedProfile = mapProfileToMyProfileSubmit(thisUser);
    setMyProfileForm({
      ...mappedProfile,
    });
  };

  useEffect(() => {
    fetchProfile();
  }, [thisUser]);

  useEffect(() => {
    if (userId) {
      getCurrentUser(userId);
    } else {
      fetchUserDetails();
    }
  }, [userId]);

  const triggerProfileAvatar = React.useCallback((avatarUrl: string) => {
    // Fires on the initial avatar fetch too (image goes from undefined to a URL on mount),
    // which isn't a user edit — real avatar edits are already tracked via avatarAction, so
    // guard here unconditionally to keep the watch subscription from marking the form dirty.
    isHydratingFormRef.current = true;
    try {
      setValue('profile_img', avatarUrl, { shouldValidate: true });
      setMyProfileForm({
        ...getValues(),
        profile_img: avatarUrl,
      });
    } finally {
      isHydratingFormRef.current = false;
    }
  }, []);

  const onCloseConfirmationModal = (): void => {
    setShowValidationAddressModal({
      isOpen: false,
      title: '',
      whatYouEntered: '',
      recommended: false,
      recommendedAddress: '',
      onClose: undefined,
      onConfirmChange: undefined,
      onKeepCurrentAddress: undefined,
    });
  };

  const callSaveProfile = async (profileData: UnifiedProfileSubmit): Promise<void> => {
    setIsSavingProfile(true);
    if (avatarPayload && avatarFile && avatarAction === 'Upload') {
      const res = await registerAvatarMedia(avatarPayload);
      const mediaId = res.files[0].upload_id;
      await fetch(res.files[0].upload_url, {
        method: 'PUT',
        body: avatarFile,
        headers: { 'content-type': avatarFile.type },
      });
      await confirmAvatarMedia(mediaId, thisUser.id);
      if (imageObjectUrlRef.current) {
        URL.revokeObjectURL(imageObjectUrlRef.current);
        imageObjectUrlRef.current = null;
      }
      const avatarUrl = getUserAvatar(thisUser.id);
      setImage(avatarUrl);
      setCurrentAvatarURL(avatarUrl);
      triggerProfileAvatar(avatarUrl);
    } else if (avatarAction === 'Remove') {
      await deleteAvatar(thisUser.id);
      setImage(undefined);
      setCurrentAvatarURL('');
      triggerProfileAvatar('');
    }
    try {
      let updatedUser;
      const dataWithUpdatedDOB = updateData(profileData);
      const basicInfoPayload: BasicInfo = {
        ...(dataWithUpdatedDOB as BasicInfo),
      };

      if (thisUser) {
        const hasBasicChanged = hasBasicInfoChanged(thisUser, basicInfoPayload);

        if (thisUser.basic_info !== null) {
          if (hasBasicChanged) {
            updatedUser = await saveBasicInformation(basicInfoPayload, thisUser.id);
          } else {
            updatedUser = thisUser;
          }
        } else {
          updatedUser = await createBasicInformation(basicInfoPayload, thisUser.id);
        }
      } else {
        updatedUser = thisUser;
      }

      if ('email' in profileData && thisUser?.email !== profileData.email) {
        updatedUser = await updateVerifiedEmail(thisUser?.id || 0, {
          email: profileData.email as string,
        });
      }

      const { address1, address2, city, state, zip_code } = profileData;
      const userAddress: Address = { address1, address2, city, state, zip_code };

      const normalizedPhone = (profileData as AdminMyProfileSubmit).phone_number
        ? (parsePhoneNumber((profileData as AdminMyProfileSubmit).phone_number, 'US')?.format('E.164') ?? '')
        : '';

      const updatedMePayload: UpdateMe = {
        ...(profileData as UpdateMe),
        ...(normalizedPhone && { phone_number: normalizedPhone }),
        address: userAddress,
      };

      if (thisUser && hasMeChanged(thisUser, updatedMePayload)) {
        updatedUser = await updateMe(updatedMePayload, thisUser.id);
      }

      setThisUser(updatedUser);
      setMyProfileForm({ ...getValues() });
      setAvatarAction('');
      setAvatarFile(null);
      setAvatarPayload(null);
      setHasEditedSinceSave(false);
      if (!reviewProfile) {
        dispatch(setUser({ userInfo: updatedUser }));
      }
      toast.success('Your changes have been saved');
      if (!reviewProfile) {
        setIsEditProfile(false);
      }
    } catch (error: unknown) {
      displayErrorDetails(error);
      if (!reviewProfile) {
        setIsEditProfile(false);
      }
    }
    setIsSavingProfile(false);
  };

  const fullAddress = useMemo(() => {
    if (thisUser?.address) {
      const { address1, address2, city, state, zip_code: zipCode } = thisUser.address;
      return `${address1}${address2 ? ` , ${address2}` : ''}, ${city}, ${state} ${zipCode}`;
    }

    return ' ';
  }, [thisUser]);

  const onSubmit = async (profileData: AdminMyProfileSubmit): Promise<void> => {
    await validateAddress(
      profileData,
      getValues as UseFormGetValues<UnifiedProfileSubmit>,
      validationResponseId,
      callSaveProfile,
      setValidationResponseId,
      setShowValidationAddressModal,
      onCloseConfirmationModal,
      updateCurrentAddress,
    );
  };

  const onEditProfile = (): void => {
    setIsEditProfile(true);
  };

  const onCancelEditProfile = (): void => {
    setImage(currentAvatarURL);
    setIsEditProfile(false);
  };

  useEffect(() => {
    return () => {
      if (imageObjectUrlRef.current) {
        URL.revokeObjectURL(imageObjectUrlRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (Object.keys(myProfileForm).length > 1) {
      isHydratingFormRef.current = true;
      try {
        Object.keys(myProfileForm).forEach((key: unknown) => {
          setValue(key as keyof AdminMyProfileSubmit, myProfileForm[key as keyof AdminMyProfileSubmit]);
        });
      } finally {
        isHydratingFormRef.current = false;
      }
      setRender(true);
      if (!reviewProfile) setLoading(false);
    }
  }, [myProfileForm]);

  const onInvalid = (errorsList: any): void => {
    const error = Object.values(errorsList)[0] as any;
    if (error) {
      toast.error(error.message as string);
    }
  };

  const displayPhoneNumber = useMemo(() => {
    if (thisUser?.phone_number) {
      const phoneNumber = parsePhoneNumber(thisUser?.phone_number, 'US');
      if (phoneNumber) {
        return phoneNumber.formatNational();
      }
    }

    return '';
  }, [thisUser]);

  const displayEmail = useMemo(() => {
    if (thisUser?.email) {
      return thisUser.email;
    }

    return '';
  }, [thisUser]);

  const [selection, setSelection] = React.useState<[number | null, number | null] | null>(null);
  const ref = React.useRef<HTMLInputElement>(null);

  React.useLayoutEffect(() => {
    if (selection && ref.current) {
      [ref.current.selectionStart, ref.current.selectionEnd] = selection;
    }
  }, [selection]);

  const setTextValue = (e: React.ChangeEvent<HTMLInputElement>, name: string): void => {
    const { value } = e.target;
    setValue(name as keyof AdminMyProfileSubmit, value, {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    });
    setSelection([e.target.selectionStart, e.target.selectionEnd]);
  };

  const renderEditProfile = (): JSX.Element => {
    return (
      <div className={styles.editProfileContainer}>
        {!reviewProfile && (
          <div className={styles.titleContainer}>
            <span className={styles.title}>Profile</span>
          </div>
        )}
        <div className={styles.editContainer}>
          {!reviewProfile && (
            <ProfileImage
              reviewProfile={reviewProfile}
              id={userId}
              setCurrentAvatarURL={setCurrentAvatarURL}
              setAvatarFile={setAvatarFile}
              setAvatarPayload={setAvatarPayload}
              setAvatarAction={setAvatarAction}
              triggerProfileAvatar={triggerProfileAvatar}
              setImage={setImage}
              image={image}
              errors={errors}
              size="80px"
            />
          )}
          {!reviewProfile && (
            <p className={styles.requiredIndicator}>
              Required <span>*</span>
            </p>
          )}
          <form ref={formRef} className={styles.formContainer} onSubmit={handleSubmit(onSubmit, onInvalid)}>
            <div className={cn(styles.row, styles.nameRow)}>
              <div className={cn(styles.rowItem, styles.detailsCA)}>
                <div className={styles.caption}>
                  First Name <span>*</span>
                </div>
                <TextField
                  errors={errors}
                  name="first_name"
                  value={watchedValues.first_name || ''}
                  onChange={(e) => setTextValue(e, 'first_name')}
                  wrapperClassName={styles.inputWrapper}
                  inputClass={styles.input}
                />
              </div>
              <div className={cn(styles.rowItem, styles.detailsCA)}>
                <div className={styles.caption}>Middle Name</div>
                <TextField
                  errors={errors}
                  name="middle_name"
                  value={watchedValues.middle_name || ''}
                  onChange={(e) => setTextValue(e, 'middle_name')}
                  wrapperClassName={styles.inputWrapper}
                  inputClass={styles.input}
                />
              </div>
              <div className={cn(styles.rowItem, styles.detailsCA)}>
                <div className={styles.caption}>
                  Last Name <span>*</span>
                </div>
                <TextField
                  errors={errors}
                  name="last_name"
                  value={watchedValues.last_name || ''}
                  onChange={(e) => setTextValue(e, 'last_name')}
                  wrapperClassName={styles.inputWrapper}
                  inputClass={styles.input}
                />
              </div>
            </div>
            <div className={styles.separator} />
            <div className={styles.row}>
              <AddressSection
                register={register}
                errors={errors}
                getValues={getValues}
                setTextValue={setTextValue}
                setValue={setValue}
                showValidationAddressModal={showValidationAddressModal}
                required
              />
            </div>
            <div className={styles.row}>
              <div className={styles.rowItem}>
                <div className={styles.caption}>Phone Number</div>
                <div className={styles.inputWrapper}>
                  <OldPhoneInput
                    value={watchedValues.phone_number as E164Number}
                    id="phone_number"
                    onChange={(val) => {
                      setValue('phone_number', val as string, {
                        shouldDirty: true,
                        shouldTouch: true,
                        shouldValidate: true,
                      });
                    }}
                    inputClass={styles.input}
                    errors={errors}
                    wrapperClassName={styles.inputWrapper}
                    ref={phoneInputRef}
                  />
                </div>
              </div>
            </div>
            <div className={styles.separator} />
            <div className={styles.row}>
              <div className={styles.rowItem}>
                <div className={styles.caption}>
                  Email Address <span>*</span>
                </div>
                <TextField
                  errors={errors}
                  name="email"
                  value={watchedValues.email || ''}
                  onChange={(e) => setTextValue(e, 'email')}
                  wrapperClassName={styles.inputWrapper}
                  inputClass={styles.input}
                />
              </div>
            </div>
            <div className={styles.actionBtnContainer}>
              {!reviewProfile && (
                <Button type="button" className={styles.cancel} onClick={onCancelEditProfile}>
                  Cancel
                </Button>
              )}
              <Button
                type="submit"
                className={styles.submit}
                disabled={!hasUnsavedChanges || isSavingProfile}
              >
                Save
              </Button>
            </div>
          </form>
        </div>
      </div>
    );
  };

  const renderReadOnlyProfile = (): JSX.Element => {
    return (
      <div className={styles.readOnlyProfileContainer}>
        <div className={styles.titleContainer}>
          <span className={styles.title}>Profile</span>
          {!(
            userInfo.role.name === UserRoleName.Admin &&
            (roleName === UserRoleName.SuperAdmin ||
              roleName === UserRoleName.Admin ||
              roleName === UserRoleName.OrganizationAdmin)
          ) && (
            <button className={styles.editBtn} type="button" onClick={onEditProfile}>
              Edit
              <FiEdit className={styles.editIcon} />
            </button>
          )}
        </div>
        <div className={styles.detailsContainer}>
          {!reviewProfile && (
            <ProfileImage
              reviewProfile={reviewProfile}
              id={userId}
              image={image}
              setImage={setImage}
              className={styles.profileImg}
              size="80px"
              isUpload={false}
            />
          )}
          <div className={styles.readOnlyItem}>
            <div className={styles.caption}>Name</div>
            <div className={styles.value}>
              {thisUser?.basic_info?.first_name} {thisUser?.basic_info?.last_name}
            </div>
          </div>
          {thisUser?.phone_number && (
            <div className={styles.readOnlyItem}>
              <div className={styles.caption}>Phone Number</div>
              <div className={styles.value}>{displayPhoneNumber}</div>
            </div>
          )}
          {thisUser?.email && (
            <div className={styles.readOnlyItem}>
              <div className={styles.caption}>Email</div>
              <div className={styles.value}>{displayEmail}</div>
            </div>
          )}
          <div className={styles.readOnlyItem}>
            <div className={styles.caption}>Address</div>
            <div className={styles.value}>{fullAddress}</div>
          </div>
        </div>
      </div>
    );
  };

  if (!render) {
    return <Loading fullScreen />;
  }

  if (loading) {
    return <Loading fullScreen />;
  }

  if (!reviewProfile) {
    return (
      <Container
        patientDashboard
        childClassName={styles.dashboard}
        isSidenavVisible
        childrenStyle={{ alignItems: 'flex-start' }}
      >
        <div className={newProfileStyles.profileContainer}>
          <form ref={formRef} className={newProfileStyles.formWrapper} onSubmit={handleSubmit(onSubmit, onInvalid)}>
            <div className={newProfileStyles.avatarRow}>
              <ProfileImage
                reviewProfile={false}
                id={undefined}
                setCurrentAvatarURL={setCurrentAvatarURL}
                setAvatarFile={setAvatarFile}
                setAvatarPayload={setAvatarPayload}
                setAvatarAction={setAvatarAction}
                triggerProfileAvatar={triggerProfileAvatar}
                setImage={setImage}
                image={image}
                errors={errors}
                size="72px"
                isUpload={false}
              />
              <MuiButton
                variant="text"
                component="label"
                sx={{
                  textTransform: 'none',
                  fontWeight: 500,
                  fontSize: '15px',
                  borderRadius: '32px',
                  color: 'var(--primary-color)',
                }}
              >
                Upload profile picture
                <input
                  type="file"
                  hidden
                  accept=".png,.jpg,.jpeg,.jfif,.pjpeg,.pjp,.heic"
                  onChange={(e) => {
                    const file = e.target.files?.[0];
                    if (file) {
                      setAvatarAction('Upload');
                      setImage(() => {
                        if (imageObjectUrlRef.current) {
                          URL.revokeObjectURL(imageObjectUrlRef.current);
                        }
                        const objectUrl = URL.createObjectURL(file);
                        imageObjectUrlRef.current = objectUrl;
                        return objectUrl;
                      });
                      setAvatarPayload({ files: [{ filename: file.name, mimetype: file.type }] });
                      setAvatarFile(file);
                    }
                  }}
                />
              </MuiButton>
            </div>

            <div className={newProfileStyles.nameRow}>
              <CustomTextField
                name="first_name"
                label="First name"
                required
                value={watchedValues.first_name || ''}
                onChange={(e) => setTextValue(e, 'first_name')}
                errors={errors}
              />
              <CustomTextField
                name="middle_name"
                label="Middle name (optional)"
                value={watchedValues.middle_name || ''}
                onChange={(e) => setTextValue(e, 'middle_name')}
                errors={errors}
              />
              <CustomTextField
                name="last_name"
                label="Last name"
                required
                value={watchedValues.last_name || ''}
                onChange={(e) => setTextValue(e, 'last_name')}
                errors={errors}
              />
            </div>

            <AddressSection
              register={register}
              errors={errors}
              getValues={getValues}
              setTextValue={setTextValue}
              setValue={setValue}
              showValidationAddressModal={showValidationAddressModal}
              required
            />

            <MuiPhoneInput
              name="phone_number"
              label="Phone number"
              value={watchedValues.phone_number as E164Number}
              onChange={(val) =>
                setValue('phone_number', val as string, {
                  shouldDirty: true,
                  shouldTouch: true,
                  shouldValidate: true,
                })
              }
              errors={errors}
              ref={phoneInputRef}
            />

            <CustomTextField
              name="email"
              label="Email address"
              required
              value={watchedValues.email || ''}
              onChange={(e) => setTextValue(e, 'email')}
              errors={errors}
            />


            <div className={newProfileStyles.buttonRow}>
              <MuiButton
                type="submit"
                variant="contained"
                className={newProfileStyles.saveButton}
                disabled={!hasUnsavedChanges || isSavingProfile}
                sx={{
                  textTransform: 'none',
                  fontWeight: 500,
                  fontSize: '15px',
                  borderRadius: '32px',
                  px: '22px',
                  py: '8px',
                  backgroundColor: 'var(--primary-color)',
                  '&:hover': { backgroundColor: '#245fa0' },
                  '&.Mui-disabled': { backgroundColor: '#bdbdbd', color: '#fff' },
                }}
              >
                Save changes
              </MuiButton>
              <MuiButton
                type="button"
                variant="text"
                onClick={() => setChangePasswordOpen(true)}
                sx={{
                  textTransform: 'none',
                  fontWeight: 500,
                  fontSize: '15px',
                  borderRadius: '32px',
                  color: '#d32f2f',
                  py: '8px',
                  '&:hover': { backgroundColor: 'rgba(211, 47, 47, 0.04)' },
                }}
              >
                Reset password
              </MuiButton>
            </div>
          </form>
        </div>

        <ChangePasswordModal
          isOpen={changePasswordOpen}
          onClose={() => setChangePasswordOpen(false)}
          email={thisUser.email || userInfo?.email || ''}
        />
        {showModal && (
          <UnsavedChangesModal
            isOpen={showModal}
            onConfirm={confirmNavigation}
            saveChange={saveChanges}
            loading={isSavingProfile}
            hideModal={hideModal}
          />
        )}
      </Container>
    );
  }

  return (
    <div className={`${styles.profileContainer} ${reviewProfile ? styles.profileContainerReview : ''}`}>
      {!reviewProfile && (
        <>
          <img className={styles.bkgTopImage} src={BlueCircle} alt="profile" />
          <img className={styles.bkgBottomImage} src={GrayCircle} alt="profile" />
          <Sidenav isVisibleOnMobile />
        </>
      )}
      <div className={styles.contentContainer}>
        {reviewProfile && (
          <ModernReviewProfileHeader
            thisUser={thisUser}
            setThisUser={setThisUser}
            userId={userId}
            resetEmailSent={resetEmailSent}
            setResetPasswordConfirmation={setResetPasswordConfirmation}
            setChangeUserStatusFlag={setChangeUserStatusFlag}
            setCurrentAvatarURL={setCurrentAvatarURL}
            setAvatarFile={setAvatarFile}
            setAvatarPayload={setAvatarPayload}
            setAvatarAction={setAvatarAction}
            triggerProfileAvatar={triggerProfileAvatar}
            setImage={setImage}
            image={image}
            errors={errors}
            roleName={userInfo.role.name}
          />
        )}
        {isEditProfile ? renderEditProfile() : renderReadOnlyProfile()}
      </div>
      {showModal && (
        <UnsavedChangesModal
          isOpen={showModal}
          onConfirm={confirmNavigation}
          saveChange={saveChanges}
          loading={isSavingProfile}
          hideModal={hideModal}
        />
      )}
      {resetPasswordConfirmation.isOpen && (
        <ResetPasswordModal
          setOpenModal={setResetPasswordConfirmation}
          disableButton={disableButton}
          userId={Number(userId)}
          userEmail={thisUser.email}
          userName={thisUser.full_name}
          isDeactivated={thisUser.status === 'Deactivated'}
          userState={resetPasswordConfirmation.userState}
        />
      )}
      {changeUserStatusFlag && (
        <ChangeUserStatusModal
          setOpenModal={setChangeUserStatusFlag}
          disableButton={disableDeleteButton}
          userId={Number(userId)}
          userName={thisUser.full_name}
          status={changeUserStatusFlag}
          thisUser={thisUser}
          setThisUser={setThisUser}
        />
      )}
    </div>
  );
};
MyProfile.defaultProps = {
  reviewProfile: false,
};
export default MyProfile;
